<!-- Seletor de imóveis: âmbito, pesquisa, filtros e a lista (2026-10-27) -->
<div class="chat-pp">
  <div class="chat-pp__top">
    <div class="chat-pp__bar">
      <label class="chat-pp__search form-control d-flex align-items-center gap-2 mb-0">
        <span class="visually-hidden">{{ strings.propertySearchLabel }}</span>
        <chat-icon name="search" [size]="16"></chat-icon>
        <input type="search" class="chat-pp__search-input flex-grow-1 border-0 bg-transparent" autocomplete="off"
          [placeholder]="strings.propertySearchPlaceholder" [value]="query" (input)="onQuery($event)">
      </label>
      <button type="button" class="btn btn-light chat-pp__filters-btn" [class.active]="filtersOpen" [attr.aria-expanded]="filtersOpen"
        (click)="filtersOpen = !filtersOpen">
        <i class="ri-filter-3-line" aria-hidden="true"></i>{{ strings.pickerFilters }}
        <span *ngIf="activeFilters > 0" class="chat-pp__count">{{ activeFilters }}</span>
      </button>
    </div>

    <!-- âmbito: os meus imóveis, a minha agência (por omissão) ou a rede (2026-10-28) -->
    <div class="chat-pp__scope" role="radiogroup" [attr.aria-label]="strings.pickerScopeLabel">
      <button type="button" role="radio" class="chat-pp__scope-btn" [class.chat-pp__scope-btn--on]="scope === 'mine'"
        [attr.aria-checked]="scope === 'mine'" (click)="setScope('mine')">{{ strings.pickerMine }}</button>
      <button type="button" role="radio" class="chat-pp__scope-btn" [class.chat-pp__scope-btn--on]="scope === 'store'"
        [attr.aria-checked]="scope === 'store'" (click)="setScope('store')">{{ strings.pickerMyAgency }}</button>
      <button *ngIf="hasNetworkScope" type="button" role="radio" class="chat-pp__scope-btn" [class.chat-pp__scope-btn--on]="scope === 'network'"
        [attr.aria-checked]="scope === 'network'" (click)="setScope('network')">{{ strings.pickerNetwork }}</button>
    </div>

    <div *ngIf="filtersOpen" class="chat-pp__filters">
      <div class="row g-2">
        <div class="col-12 col-md-6">
          <ng-select [items]="districtOptions" bindLabel="name" bindValue="id" [multiple]="true" [closeOnSelect]="false" appendTo="body"
            [placeholder]="strings.pickerDistrict" [(ngModel)]="districts" (change)="onDistrictsChange()"></ng-select>
        </div>
        <div class="col-12 col-md-6">
          <ng-select [items]="countyOptions" bindLabel="name" bindValue="id" [multiple]="true" [closeOnSelect]="false" appendTo="body"
            [placeholder]="strings.pickerCounty" [notFoundText]="strings.pickerCountyHint" [(ngModel)]="counties" (change)="search()"></ng-select>
        </div>
        <div class="col-12 col-md-6">
          <ng-select [items]="propertyTypeOptions" bindLabel="description" bindValue="id" groupBy="groupDescription" [multiple]="true"
            [closeOnSelect]="false" appendTo="body" [placeholder]="strings.pickerPropertyType" [(ngModel)]="propertyTypes"
            (change)="search()"></ng-select>
        </div>
        <div class="col-12 col-md-6">
          <ng-select [items]="businessTypeOptions" bindLabel="description" bindValue="id" [multiple]="true" [closeOnSelect]="false"
            appendTo="body" [placeholder]="strings.pickerBusiness" [(ngModel)]="businessTypes" (change)="search()"></ng-select>
        </div>
        <div class="col-12 col-md-6">
          <ng-select [items]="typologyOptions" bindLabel="name" bindValue="id" [multiple]="true" [closeOnSelect]="false" appendTo="body"
            [placeholder]="strings.pickerTypology" [(ngModel)]="typology" (change)="search()"></ng-select>
        </div>
        <div class="col-6 col-md-3">
          <input type="number" min="0" step="1000" class="form-control" [placeholder]="strings.pickerPriceMin" [attr.aria-label]="strings.pickerPriceMin"
            [(ngModel)]="priceMin" (ngModelChange)="search()">
        </div>
        <div class="col-6 col-md-3">
          <input type="number" min="0" step="1000" class="form-control" [placeholder]="strings.pickerPriceMax" [attr.aria-label]="strings.pickerPriceMax"
            [(ngModel)]="priceMax" (ngModelChange)="search()">
        </div>
      </div>
      <div class="chat-pp__filters-foot">
        <span *ngIf="presetTypeGroups.length > 0" class="chat-pp__tag">
          {{ strings.pickerFromRequest }}
          <button type="button" class="chat-pp__tag-x" [attr.aria-label]="strings.pickerRemoveTag" (click)="removePresetTypes()">
            <chat-icon name="close" [size]="11"></chat-icon>
          </button>
        </span>
        <button *ngIf="activeFilters > 0" type="button" class="btn btn-link btn-sm p-0 ms-auto" (click)="clearFilters()">{{ strings.pickerClear }}</button>
      </div>
    </div>
    <p class="chat-pp__hint">{{ strings.pickerOnlyAvailable }}</p>
  </div>

  <div class="chat-pp__list">
    <p *ngIf="loading && results.length === 0" class="text-muted px-3 py-2 mb-0" role="status">{{ strings.loading }}</p>
    <p *ngIf="!loading && results.length === 0" class="text-muted px-3 py-3 mb-0">{{ strings.propertyEmpty }}</p>
    <label *ngFor="let p of results; trackBy: trackByPick" class="chat-pp__row" [class.chat-pp__row--on]="isSelected(p)">
      <input [type]="mode === 'confirm' ? 'radio' : 'checkbox'" class="form-check-input mt-0 flex-shrink-0" [checked]="isSelected(p)"
        (change)="toggle(p)">
      <span class="chat-pp__photo"><img *ngIf="p.image" [src]="p.image" alt="" loading="lazy"></span>
      <span class="chat-pp__text">
        <span class="chat-pp__title">{{ p.title || p.reference }}</span>
        <span class="chat-pp__meta">{{ p.reference }}<ng-container *ngIf="p.location"> · {{ p.location }}</ng-container></span>
      </span>
      <span class="chat-pp__price">{{ priceText(p) }}</span>
    </label>
    <button *ngIf="hasMore" type="button" class="chat-pp__more" [disabled]="loadingMore" (click)="loadMore()">
      {{ loadingMore ? strings.loading : strings.pickerShowMore.replace('{shown}', '' + results.length).replace('{total}', '' + total) }}
    </button>
  </div>
</div>
